import { right, left } from "fp-ts/lib/Either";
import Constants, { ConstantsName } from "../../../../../constants/Constants";
import di from "../../../../../di/DependencyInjection";
import callAPI from "../../../fetchCallImplementation";

const GetS3RagRegisteredPathApiImpl = async (s3_key: string, customer: string): Promise<any> => {
    const body = { s3_key, customer };

    const baseUrl = di.get<Constants>(ConstantsName).RAG;

    const url = new URL(`${baseUrl}/upload-file`);

    const response = await callAPI(url.toString(), 'POST', body);

    const reader = response.body?.getReader();
    if (!reader) {
        return left("No readable response stream.");
    }

    let result = '';
    const decoder = new TextDecoder();

    while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        result += decoder.decode(value, { stream: true });
    }

    result += decoder.decode(); // final flush

    try {
        const parsed = JSON.parse(result);

        const ragResponse = parsed?.rag_response;
        const statusCode = ragResponse?.statusCode;
        const responseBodyRaw = ragResponse?.body;

        let errorMessage = 'Unknown error';

        if (statusCode !== 200) {
            // Parse the body string to extract error message
            if (typeof responseBodyRaw === 'string') {
                try {
                    const bodyParsed = JSON.parse(responseBodyRaw);
                    errorMessage = bodyParsed?.error || errorMessage;
                } catch (e) {
                    errorMessage = responseBodyRaw;
                }
            }
            return left(`${errorMessage}`);
        }

        return right(result); // success

    } catch (err: any) {
        return left(`Failed to parse response: ${err.message}`);
    }
};

export default GetS3RagRegisteredPathApiImpl;
